import { configureStore } from '@reduxjs/toolkit';
import headerSlice from '../features/common/headerSlice';
import modalSlice from '../features/common/modalSlice';
import { setupListeners } from '@reduxjs/toolkit/query'
import { apiSlice } from './apiSlice';

const combinedReducer = {
  header: headerSlice,
  modal: modalSlice,
  [apiSlice.reducerPath]: apiSlice.reducer, // Add the API reducer
};

const store = configureStore({
  reducer: combinedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware), // Add the API middleware
});

setupListeners(store.dispatch);
export default store;
